import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchMyBooking from "app/pages/Account/SearchMyBooking/SearchMyBooking";
import { bindActionCreators } from "redux";
import { searchBooking } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import { updateEmail } from "app/reducers/emailActionCreators";
import { HTTP_STATUS_CODES } from "app/constants";
import { isWhiteLabel } from "app/reducers/brandSelector";
import { getBrandDisplayName } from "app/reducers/partnerSelector";

const searchBookingErrorGenerate = status =>
	({
		[HTTP_STATUS_CODES.NOT_FOUND]: "error.booking.not.found.error",
		[HTTP_STATUS_CODES.TOO_MANY_REQUEST]: "error.booking.too.many.request.error",
	}[status] || "error.generic");

const SearchMyBookingContainer = ({
	searchBooking = () => {},
	updateEmail = () => {},
	isWhiteLabel,
	brandDisplayName,
}) => {
	const [myBookingError, setMyBookingError] = useState();
	const { brand, shop, partnerCode } = useContext(AppGlobalsContext);
	const navigate = useNavigate();

	const handleFormSuccess = useCallback(
		(bookingReference, email) => {
			return searchBooking({
				brandDisplayName,
				bookingReference,
				email,
				brand: brand?.toUpperCase(),
				partnerCode,
				shop,
			})
				.then(res => {
					if (res.status === HTTP_STATUS_CODES.OK) {
						setMyBookingError(null);
						updateEmail(email);
						navigate(`/otp?token=${res?.data?.token}`, {
							replace: true,
							state: {
								email,
								bookingReference,
							},
						});
					} else {
						setMyBookingError(searchBookingErrorGenerate(res.status));
					}

					return res;
				})
				.catch(err => {
					const status = err?.response?.status;
					setMyBookingError(searchBookingErrorGenerate(status));
					return Promise.reject(err);
				});
		},
		[brand]
	);

	return (
		<SearchMyBooking
			onFormSuccess={handleFormSuccess}
			myBookingError={myBookingError}
			setMyBookingError={setMyBookingError}
			isWhiteLabel={isWhiteLabel}
		/>
	);
};

const mapStateToProps = state => {
	return {
		isWhiteLabel: isWhiteLabel(state),
		brandDisplayName: getBrandDisplayName(state),
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({ searchBooking, updateEmail }, dispatch);

SearchMyBookingContainer.propTypes = {
	searchBooking: PropTypes.func,
	isWhiteLabel: PropTypes.bool,
	updateEmail: PropTypes.func,
	brandDisplayName: PropTypes.string,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchMyBookingContainer);
